import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import HotShows from './components/HotShows';
import FeaturedArticles from './components/FeaturedArticles';
import StatsCounter from './components/StatsCounter';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroBanner />
        <CategorySection />
        <HotShows
          title="热门综艺推荐"
          filter={(s) => s.isHot}
          limit={8}
        />
        <HotShows
          title="最新上线"
          filter={(s) => s.isNew}
          limit={8}
        />
        <StatsCounter />
        <FeaturedArticles />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}